import { List, ListItem, ListItemText, Popover, Typography, Box } from '@mui/material';
import React from 'react';

const PodInfo = ({ podStatus, podData }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const getPodDataList = () => {
    if (!podData)
      return [{ "podName": "No info present" }]
    const output = []
    for (const podName in podData) {
      const obj = {
        podName,
        info: " "
      }
      for (const status in podData[podName]) {
        obj.info = obj.info + podData[podName][status] + " " + status + "/"
      }
      obj.info = obj.info.slice(0, -1)
      output.push(obj)
    }
    if (output.length === 0)
      output.push({ "podName": "No pods found" })
    return output
  }
  const handleClick = (event) => {
    if (podData)
      setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  let color = '#0f172a'; // Default slate-900
  let bgColor = '#f1f5f9'; // Default slate-100

  if (podStatus === "Pending") {
    color = "#b45309"; // Amber-700
    bgColor = "#ffedd5"; // Amber-100
  } else if (podStatus === "Running") {
    color = "#15803d"; // Green-700
    bgColor = "#dcfce7"; // Green-100
  } else if (podStatus?.includes('Fail') || podStatus?.includes('Error')) {
    color = "#b91c1c"; // Red-700
    bgColor = "#fee2e2"; // Red-100
  } else if (podStatus === "Completed") {
    color = "#1e40af"; // Blue-800
    bgColor = "#dbeafe"; // Blue-100
  }

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <Typography
          variant='caption'
          onClick={handleClick}
          sx={{
            cursor: 'pointer',
            fontWeight: 600,
            color: color,
            backgroundColor: bgColor,
            borderRadius: '999px',
            px: 1.5,
            py: 0.5,
            display: 'inline-block',
            lineHeight: 1.2
          }}
        >
          {podStatus}
        </Typography>
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <List dense>
          {getPodDataList().map(item => (
            <ListItem sx={{ py: '1px' }} key={item["podName"]}>
              <ListItemText
                sx={{ margin: '1px' }}
                primary={item["podName"]}
                secondary={item["info"]}
              />
            </ListItem>)
          )}
        </List>
      </Popover>
    </>
  );
}

export default PodInfo;
